import Add from './Add';
import Alarm from './Alarm';
import ArrowForward from './ArrowForward';
import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';
import { BznavRefundLogo } from './BznavRefundLogo';
import CalculateMinus from './CalculateMinus';
import CalculatePlus from './CalculatePlus';
import Calendar from './Calendar';
import CarTool from './CarTool';
import CashReceiptPurchase from './CashReceiptPurchase';
import CheckEmpty from './CheckEmpty';
import CheckLine from './CheckLine';
import CheckSolid from './CheckSolid';
import Checkmark from './Checkmark';
import Close from './Close';
import Consult from './Consult';
import DataSync from './DataSync';
import DescriptionImage from './DescriptionImage';
import Error from './Error';
import ExpandLess from './ExpandLess';
import ExpandMore from './ExpandMore';
import EyesClose from './EyesClose';
import EyesOpen from './EyesOpen';
import FillAccount from './FillAccount';
import FillCards from './FillCards';
import FillDate from './FillDate';
import HometaxCircle from './HometaxCircle';
import KakaoCircle from './KakaoCircle';
import KakaoPay from './KakaoPay';
import KakaoRectangle from './KakaoRectangle';
import ListinRight from './ListinRight';
import Lock from './Lock';
import MemberSolid from './MemberSolid';
import MoneyBag from './MoneyBag';
import MoreVertical from './MoreVertical';
import Npay from './Npay';
import Payco from './Payco';
import Point from './Point';
import SamsungPay from './SamsungPay';
import Send from './Send';
import StateErrorLine from './StateErrorLine';
import StateErrorSolid from './StateErrorSolid';
import StateFatal from './StateFatal';
import StateHelp from './StateHelp';
import StateInfo from './StateInfo';
import StateProgress from './StateProgress';
import SwipeRight from './SwipeRight';
import Toss from './Toss';
import Warning from './Warning';

const ICON_DICTIONARY = {
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-forward': ArrowForward,
  close: Close,
  'check-mark': Checkmark,
  'check-solid': CheckSolid,
  'state-error-solid': StateErrorSolid,
  'state-info': StateInfo,
  'eyes-open': EyesOpen,
  'eyes-close': EyesClose,
  'expand-more': ExpandMore,
  calendar: Calendar,
  'calculate-minus': CalculateMinus,
  'calculate-plus': CalculatePlus,
  add: Add,
  'state-progress': StateProgress,
  'listin-right': ListinRight,
  'swipe-right': SwipeRight,
  send: Send,
  alarm: Alarm,
  member: MemberSolid,
  'state-error-line': StateErrorLine,
  'state-fatal': StateFatal,
  'state-help': StateHelp,
  'data-sync': DataSync,
  'check-line': CheckLine,
  'check-empty': CheckEmpty,
  'money-bag': MoneyBag,
  'description-image': DescriptionImage,
  'kakao-circle': KakaoCircle,
  'kakao-rectangle': KakaoRectangle,
  'expand-less': ExpandLess,
  warning: Warning,
  lock: Lock,
  'car-tool': CarTool,
  'cash-receipt-purchase': CashReceiptPurchase,
  'hometax-circle': HometaxCircle,
  error: Error,
  npay: Npay,
  'kakao-pay': KakaoPay,
  payco: Payco,
  toss: Toss,
  'fill-cards': FillCards,
  'fill-account': FillAccount,
  'fill-date': FillDate,
  'samsung-pay': SamsungPay,
  point: Point,
  consult: Consult,
  'more-vertical': MoreVertical,
  'bznav-refund-logo': BznavRefundLogo
};

export default ICON_DICTIONARY;
